import React from 'react';
import VectorIcon from './VectorIcon';
import colors from '../../theme/colors';

type Props = {
  radius?: number;
  colorCircle?: string;
  colorIcon?: string;
};

const CircleCheckIcon = ({
  radius = 16,
  colorCircle = colors.madison,
  colorIcon = colors.white,
}: Props): JSX.Element => (
  <VectorIcon width={radius} height={radius}>
    <circle
      cx={radius / 2.0}
      cy={radius / 2.0}
      r={radius / 2.0}
      fill={colorCircle}
    />
    <path
      d="M11.8031 6.17612C12.0656 5.90713 12.0656 5.47087 11.8031 5.20174C11.5407 
      4.93275 11.1151 4.93275 10.8525 5.20174L6.81864 9.33676L5.14736 7.62363C4.88494 7.3545 
      4.45934 7.3545 4.19692 7.62363C3.93436 7.89262 3.93436 8.32887 4.19692 8.59787L6.34342 
      10.7983C6.60597 11.0672 7.03144 11.0672 7.29399 10.7983L11.8031 6.17612Z"
      fill={colorIcon}
    />
  </VectorIcon>
);

export default CircleCheckIcon;
